<template>
          <div class="row">
            <div class="col-12 mb-4">
              <SoftButton @click="goBack()" type="button" color="primary"> 
                <i
                class="fas fa-arrow-left text-sm ms-1"
                aria-hidden="true"
                ></i> &nbsp;&nbsp; Back to Menu
              </SoftButton>
            </div>
            <div class="col-12">
              <div class="card mb-4" style="padding: 15px;">
                <div style="display: flex; justify-content: space-between; align-items: center; cursor: pointer;">
                  <div style="min-width: 310px;
                    max-width: 350px; display: flex; align-items: center; gap: 5px;">
                    <b>Team</b>
                    <Multiselect 
                    style="border-radius: 0.5rem; "
                      @change="sendFilter()"
                      v-model="doc_collections.value"
                      v-bind="doc_collections"
                      placeholder="Select a team"
                    ></Multiselect>
                  </div>
                  <soft-button style="display: flex; gap: 5px;" @click="reloadFaqs()" color="success" size="md" variant="outline">
                    <span v-show="loader" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Refresh
                  </soft-button>
                </div>
              </div>
            </div>
            <soft-alert v-show="showResponseMessage === true" color="danger" icon="ni ni-unlike-2 ni-lg" dismissible>
              <strong> {{ responseMessage }} </strong>
            </soft-alert>
            <soft-alert v-show="showUploadMessage === true" color="success" icon="ni ni-unlike-2 ni-lg" dismissible>
              <strong> {{ uploadMessage }} </strong>
            </soft-alert>
            <soft-alert v-show="questionCorrect === true" color="success" icon="ni ni-unlike-2 ni-lg" dismissible>
              <strong> Question uploaded correctly! </strong>
            </soft-alert>
            <soft-alert v-show="questionDeleted === true" color="success" icon="ni ni-unlike-2 ni-lg" dismissible>
              <strong> Question deleted correctly! </strong>
            </soft-alert>
            <div class="col-12">
              <div class="card">
                <div class="card-header pb-0 mb-4">
                  <div style="display: flex; align-items: center; justify-content: space-between;">
                    <div style="display: flex;
                      gap: 10px;
                      align-items: baseline;">
                      <h6 style="margin: 0"><span style="color: #cb0c9f;font-weight: 600;">{{K.fNumber(dataQuestions.length)}}</span> <span v-if="dataQuestions.length !== 1">Questions</span><span v-else>Question</span></h6>
                      
                    </div>
                    <div data-bs-toggle="modal" data-bs-target="#importFaq"
                      style="display: flex;
                      align-items: center;
                      gap: 10px;">
                      <a style="margin: 0;" class="btn text-secondary font-weight-bold">Import FAQs</a>
                      <SoftButton data-bs-toggle="modal" data-bs-target="#newQuestion" @click="newQuestion()">
                        New question
                      </SoftButton>
                    </div>
                  </div>
                </div>
                <div style="height: 400px; display: flex; align-items: center; justify-content: center;" v-if="loading">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </div>
                <div v-else>
                  <div v-show="dataQuestions.length !== 0" style="max-height: 720px; overflow-y: scroll; height: 400px; padding: 15px !important;">
                    <div  class="table-responsive" style="min-width: 800px;">
                      <table class="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th
                              class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                              Question
                            </th>
                            <th
                              class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                            >
                              Answer
                            </th>
                            <th
                              class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                              Delete
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="row in dataQuestions" v-bind:key="row">
                            <td style="width: 40%;">
                              <div style="max-height: 150px; white-space: break-spaces; word-break: keep-all; overflow: hidden;" 
                                class="text-xs text-bold mb-0">
                                {{ row.question }}
                              </div>
                            </td>
                            <td style="width: 40%;">
                                <div style="max-height: 150px; white-space: break-spaces; word-break: keep-all; overflow: hidden;" 
                                  class="text-xs text-secondary mb-0">
                                  {{ row.answer }}
                                </div>
                            </td>
                            <td class="align-middle text-center text-sm">
                              <a style="margin: 0" @click="deleteQuestion(row.token)" data-bs-toggle="modal" data-bs-target="#deleteQuestion"
                                class="btn text-secondary font-weight-bold text-xs"
                                data-toggle="tooltip"
                                data-original-title="Delete user">
                                Delete
                              </a>
                            </td>
                          </tr>
                          
                        </tbody>
                      </table>
                    </div>
                  </div>
                  
                  <div v-show="dataQuestions.length === 0" style="display: grid; justify-items: center; padding: 25px;">
                    <img style="width: 50%;" src="../../assets/img/FAQs-pana-rosa.png" /> 
                    <p class="text-2xl text-center sm:text-4xl font-bold text-darkblue-500 mb-2">
                      Ups!... no results found
                    </p>
                    <p class="text-xl text-gray-700">Add a new question to this team</p>
                    <SoftButton data-bs-toggle="modal" data-bs-target="#newQuestion" @click="newQuestion()">
                      New question
                    </SoftButton>
                  </div>
                </div>
              </div>
            </div>
            
          </div>

          <!-- Modal New Questions-->
          <div class="modal fade" data-bs-backdrop="static" id="newQuestion" tabindex="-1" aria-labelledby="newQuestionLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="teamModalLabel">New question</h5>
                  
                </div>
                <div class="modal-body">
                  <label>Teams</label>
                  <Multiselect
                  style="border-radius: 0.5rem; "
                    v-model="multipleSelect.value"
                    v-bind="multipleSelect"
                    placeholder="Select at least one team"
                  ></Multiselect>
                  
                  <label>Question</label>
                  <textarea
                    v-model="question"
                    id="received"
                    class="form-control"
                    rows="5"
                    placeholder="Write your question here"
                  ></textarea>

                  <label>Answer</label>
                  <textarea
                    v-model="answer"
                    id="response"
                    class="form-control"
                    rows="5"
                    placeholder="Write your answer here"
                  ></textarea>
                </div>
                <div class="modal-footer">
                  <SoftButton id="cerrarModal" type="button" color="secondary" data-bs-dismiss="modal">Close</SoftButton>
                  <SoftButton @click="postQuestion()">Save changes</SoftButton>
                </div>
              </div>
              <soft-alert v-show="showResponseNewQuestion === true" color="danger" icon="ni ni-unlike-2 ni-lg" dismissible>
                <strong> {{ responseNewQuestion }} </strong>
              </soft-alert>
              <soft-alert v-show="noBBDDselected === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
                <strong>Select at least one team</strong>
              </soft-alert>
            </div>
          </div>

          <!-- Modal import faq-->
          <div class="modal fade" data-bs-backdrop="static" id="importFaq" tabindex="-1" aria-labelledby="importFaqModal" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="importFaq">Import your FAQs excel</h5>
                  
                </div>
                <div class="modal-body" style="display: grid; gap: 15px;">
                  <label>Teams</label>
                  <Multiselect
                  style="border-radius: 0.5rem; "
                    v-model="multipleSelect.value"
                    v-bind="multipleSelect"
                    placeholder="Select at least one team"
                  ></Multiselect>
                  <label>Upload the excel with Questions and Answers as shown below</label>
                  <img height="60" src="../../assets/img/instrucciones-faqs.png" />
                  <div style="display: flex; align-items: baseline;">
                    <a style="display: flex;
                      align-items: center;" class="btn" onclick="document.getElementById('csvFile2').click()">
                      <i class="ni ni-folder-17"></i>&nbsp;&nbsp;Select FAQs excel
                    </a>
                    <span>&nbsp;&nbsp;{{ file }}</span>
                  </div>
                  <input style="display: none;" @change="uploadCSV($event.target.files)" type="file" id="csvFile2" />
                </div>
                <div class="modal-footer">
                  <SoftButton @click="limpiarSelectores()" id="closePostFaq" type="button" color="secondary" data-bs-dismiss="modal">Close</SoftButton>
                  <SoftButton @click="uploadFaq()" >Save changes</SoftButton>
                </div>
              </div>
              <soft-alert v-show="showResponseNewQuestion === true" color="danger" icon="ni ni-unlike-2 ni-lg" dismissible>
                <strong> {{ responseNewQuestion }} </strong>
              </soft-alert>
              <soft-alert v-show="noBBDDselected === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
                <strong>Select at least one team</strong>
              </soft-alert>
            </div>
          </div>

          <div class="modal fade" id="deleteQuestion" data-bs-backdrop="static" tabindex="-1" aria-labelledby="deleteQuestionModal" aria-hidden="true">
            <div class="modal-dialog modal-md">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="deleteModal">Delete question</h5>
                  
                </div>
                <div class="modal-body">
                  You are about to delete the question, do yo want to proceed?
                </div>
                <div class="modal-footer">
                  <SoftButton type="button" color="secondary" data-bs-dismiss="modal">Close</SoftButton>
                  <SoftButton color="danger" @click="deleteQuestion4real()" data-bs-dismiss="modal">Delete</SoftButton>
                </div>
              </div>
            </div>
          </div>
</template>

<script>
  import SoftButton from '../../components/SoftButton.vue';
  import SoftAlert from "@/components/SoftAlert.vue";
  import HTFetch from "../../llamadas/HTFetch"
  import Multiselect from '@vueform/multiselect'
  import K from "../../llamadas/K"


  export default {
    name: "questions",

    props: {
      
    },

    watch: {
    },
    
    components: {
      SoftButton,
      SoftAlert,
      Multiselect,
    },

    data() {
      return {
        showResponseNewQuestion: false,
        responseNewQuestion: "",
        loading: false,//true,
        loader: false,
        question: "",
        answer: "",
        responseMessage: "",
        showResponseMessage: false,
        uploadMessage: "",
        showUploadMessage: false,
        dataQuestions: [],
        llamada: new HTFetch(),
        K: new K(),
        multipleSelect: {
          mode: 'tags',
          value: [],
          closeOnSelect: false,
          options: [
            { value: 'batman', label: 'Batman' },
            { value: 'robin', label: 'Robin' },
            { value: 'joker', label: 'Joker' },
          ]
        },
        doc_collections: {
          value: [],
          closeOnSelect: true,
          options: [],
          canClear: false,
          canDeselect: false
        },
        noData: true,
        questionCorrect: false,
        questionDeleted: false,
        deleteToken: "",
        deleteTitle: "",
        noBBDDselected: false,
        file: null,
        base64CSV: "",
        interval: null
      };
    },

    mounted() {
      this.userInformation()
      this.refreshFaqs()
    },

    beforeUnmount() {
      // Clear the interval when the component is about to be destroyed
      clearInterval(this.interval);
    },

    computed: {
    },

    methods: {

      refreshFaqs() {
        
        this.interval = setInterval(
          () => {
            this.getQuestions()
          }, 1000*30
        )
      },

      userInformation() {
        this.llamada.userInfo(this.userInfoRsp.bind(this))
      },

      userInfoRsp(rsp) {
        if (rsp.status === 401) {
          
          this.llamada.userInfo(this.userInfoRsp.bind(this))
          return
        }
        
        let collecciones = []
        for (let i = 0; i < Object.keys(rsp.data.document_collections).length; i++) {
          collecciones.push({
            "label": Object.keys(rsp.data.document_collections)[i],
            "value": Object.values(rsp.data.document_collections)[i]
          })
        }

        localStorage.docCollections = JSON.stringify(collecciones)

        this.multipleSelect.options = collecciones
        this.doc_collections.options = collecciones
        this.doc_collections.value = collecciones[0].value

        localStorage.userId = rsp.data.token
      },

      sendFilter() {
        this.dataQuestions = []
        this.loading = true
        setTimeout(() => {
          this.getQuestions()
        }, 500)
      },

      getQuestions() {
        //this.loading = true
        this.llamada.getQuestions(this.doc_collections.value, this.getQuestionsRsp.bind(this))
      },

      getQuestionsRsp(rsp) {
        // Iterar sobre los emails en rsp.data.emails
        if (this.dataQuestions.length !== 0) {
          rsp.data.forEach(faqRsp => {
            // Verificar si el token del email actual de rsp.data.emails ya existe en this.datos.emails
            const faqExistente = this.dataQuestions.find(faqDatos => faqDatos.token === faqRsp.token);

            // Si el email con ese token no existe en this.datos.emails, lo inyectamos
            if (!faqExistente) {
              this.dataQuestions.push(faqRsp);
            }
          });
        } else {
          this.dataQuestions = rsp.data
        }
        
        setTimeout(() => {
          this.loading = false
          this.loader = false
        }, 500)

        if (this.dataQuestions.length !== 0) {
          this.noData = false
          
        } else {
          this.noData = true
        }
        
        if (rsp.status === 402) {
          if ('detail' in rsp.data) {
            this.responseMessage = rsp.data.detail
          }

          if ('Message' in rsp.data) {
            this.responseMessage = rsp.data.Message
          }

          if ('message' in rsp.data) {
            this.responseMessage = rsp.data.Message.replace("'", "").replace("[", "").replace("]", "")
          }

          if ('Error' in rsp.data) {
            this.responseMessage = rsp.data.Error.replace("'", "").replace("[", "").replace("]", "")
          }
          
          this.showResponseMessage = true

          setTimeout(() => {
            this.showResponseMessage = false
          }, 5000)
        } 
      },

      postQuestion() {
        if (this.multipleSelect.value.length === 0) {

          this.noBBDDselected = true

          setTimeout(() => {
            this.noBBDDselected = false
          }, 2000)

          return
        }

        let body = {
          "question": this.question,
          "answer": this.answer,
          "collection": this.multipleSelect.value
        }

        this.llamada.postQuestion(body, this.postQuestionRsp.bind(this))

        //mando evento
        if (this.$gtm.enabled()) {
          window.dataLayer?.push({
            event: "send-question",
            user_id: localStorage.userId
          });
        }
      },

      postQuestionRsp(rsp) {
        this.loading = true
        this.dataQuestions = []

        if (rsp.status !== 200) {

          if ('question' in rsp.data) {
            this.responseNewQuestion = rsp.data.question[0]
          }

          if ('answer' in rsp.data) {
            this.responseNewQuestion = rsp.data.answer[0]
          }

          if ('message' in rsp.data) {
            this.responseNewQuestion = rsp.data.message[0]
          }
          
          this.showResponseNewQuestion = true

          setTimeout(() => {
            this.showResponseNewQuestion = false
          }, 5000)

          return
        } else {
          this.questionCorrect = true
          document.getElementById('cerrarModal').click()

          this.multipleSelect.value = []
          this.question = ""
          this.answer = ""

          setTimeout(() => {
            this.questionCorrect = false
          }, 2000)
        }

        this.getQuestions()
        
      },

      deleteQuestion(token) {
        
        this.deleteToken = token
      },

      deleteQuestion4real() {
        let body = {
          "tokens": [this.deleteToken]
        }

        this.llamada.deleteQuestion(body, this.deleteQuestionRsp.bind(this))
      },

      deleteQuestionRsp(rsp) {
        this.loading = true
        this.dataQuestions = []

        if (rsp.status !== 200) {
          if ('detail' in rsp.data) {
            this.responseMessage = rsp.data.detail
          }

          if ('tokens' in rsp.data) {
            this.responseMessage = rsp.data.tokens
          }

          if ('message' in rsp.data) {
            this.responseMessage = rsp.data.Message.replace("'", "").replace("[", "").replace("]", "")
          }

          if ('Error' in rsp.data) {
            this.responseMessage = rsp.data.Error.replace("'", "").replace("[", "").replace("]", "")
          }
          
          this.showResponseMessage = true

          setTimeout(() => {
            this.showResponseMessage = false
          }, 5000)
        } else {
          this.questionDeleted = true
          setTimeout(() => {
            this.questionDeleted = false
          }, 2000)
        }

        this.getQuestions()
      },

      goBack() {
        console.log('el error de volver a Database está aqui')
        this.$emit('go-back')
      },

      uploadCSV(file) {
        this.file = file[0].name
        function readFile(imagen, handler) {
            var reader = new FileReader();
            
            reader.onload = () => {
                handler(reader.result);
            }
            reader.onerror = function () {
                alert('There was an error reading the file!');
            }
            reader.readAsDataURL(imagen);
        }

        readFile(file[0], function(s) {
          this.base64CSV = s.split('base64,')[1]
        }.bind(this))
      },

      uploadFaq() {
        let body = {
          'excel': this.base64CSV,
          'collection': this.multipleSelect.value
          ,
        }

        if (this.multipleSelect.value.length === 0) {

          this.noBBDDselected = true

          setTimeout(() => {
            this.noBBDDselected = false
          }, 2000)

          return
        }

        this.llamada.postFaqBatch(body, this.postFaqBatchRsp.bind(this))
      },

      postFaqBatchRsp(rsp) {
        this.loading = true
        this.dataQuestions = []

        if (rsp.status === 400) {
          if ('message' in rsp.data) {
            this.showResponseNewQuestion = true
            this.responseNewQuestion = rsp.data.message

            setTimeout(() => {
              this.showResponseNewQuestion = false
            }, 5000)
            return
          }
          if ('excel' in rsp.data) {
            this.showResponseNewQuestion = true
            this.responseNewQuestion = 'File ' + rsp.data.excel[0] 

            setTimeout(() => {
              this.showResponseNewQuestion = false
            }, 5000)
            return
          }
          if ('collection' in rsp.data) {
            this.showResponseNewQuestion = true
            this.responseNewQuestion = rsp.data.collection[0]

            setTimeout(() => {
              this.showResponseNewQuestion = false
            }, 5000)
            return
          }
        } else {
          if (rsp.status === 200) {
            document.getElementById('closePostFaq').click()

            this.showUploadMessage = true
            this.uploadMessage = rsp.data.message

            this.multipleSelect.value = []
            this.file = null

            setTimeout(() => {
              this.showUploadMessage = false
            }, 2000)

            this.getQuestions()
          }
        }
        

        if (typeof rsp === 'undefined') {
          
          return
        }
        
      },

      limpiarSelectores() {
        this.multipleSelect.value = []
        this.file = null
      },  

      newQuestion() {
        if (this.$gtm.enabled()) {
          window.dataLayer?.push({
            event: "import-new-question",
            user_id: localStorage.userId
          });
        }
      }, 

      reloadFaqs() {
        this.loading = true
        this.loader = true
        this.getQuestions()
      },
    }
    
  };
</script>

<style scoped>
    .tilting {
        -webkit-animation: fadein 2s infinite;
        animation: fadein 2s infinite;
    }

    @keyframes fadein {
        0% { opacity: 0.25;}
        100% { opacity: 1;}
    }
</style>
